import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { PRODUTO_ENDPOINT, PRODUTOS_ENDPOINT } from './constants';

const handleQueryStyrings = (busca = null, ordem = null) => {
  return `?${!!busca ? `busca=${busca}${!!ordem ? '&' : ''}` : ''}${
    !!ordem ? `ordem=${ordem}` : ''
  }`;
};

export const useGetAllProducts = (force, busca = null, ordem = null) => {
  const [result, setResult] = React.useState();
  const [loading, setLoading] = React.useState();
  const [error, setError] = React.useState();

  const { backendGet } = Sebrae.useBackend();

  React.useEffect(() => {
    setResult(null);
    setError(false);
    setLoading(true);

    backendGet(`${PRODUTOS_ENDPOINT}/${handleQueryStyrings(busca, ordem)}`)
      .then(setResult)
      .catch(() => setError(true))
      .finally(() => setLoading(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordem, busca, force]);
  return [result, loading, error];
};

export const useGetPortfolio = (portfolioId) => {
  const [result, setResult] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const { backendGet } = Sebrae.useBackend();

  React.useEffect(() => {
    if (!portfolioId) {
      setResult(null);
      setError(false);
      setLoading(false);
      return;
    }

    setResult(null);
    setError(false);
    setLoading(true);

    backendGet(`${PRODUTO_ENDPOINT}/portfolio/${portfolioId}`)
      .then(setResult)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [portfolioId, backendGet]);

  return [result, loading, error];
};
